export default "__VITE_ASSET__CmTeNlJj__"